<script>
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState('media', {
            isLoading: state => state.isLoading,
            tags: state => state.tags,
            folders: state => state.folders,
            types: state => state.types,
            totalTypeCount: state => state.totalTypeCount,
            activeTags: state => state.activeTags,
            activeFolders: state => state.activeFolders
        })
    },

    methods: {
        onChange(value) {
            this.$parent.$emit('tagChange', value);
            this.$store.commit('media/set', {
                activeTags: value
            });
        }
    }
}
</script>

<template>
    <list-group-select
        class="list-group--tags"
        :options="tags"
        :value="activeTags"
        label="name"
        countKey="tag_count"
        checkAllLabel="All Tags"
        searchPlaceholder="Find a tag"
        emptyResults="No tags found"
        @onChange="onChange">
    </list-group-select>
</template>
